import { lazy, Suspense } from "react";
import { router } from "@/router";

const devtoolsEnabled =
  process.env.NODE_ENV !== "production" &&
  localStorage.getItem("devtools") === "true";

const RouterDevtools = devtoolsEnabled
  ? lazy(() =>
      import("@tanstack/react-router-devtools").then((res) => ({
        default: res.TanStackRouterDevtools,
      }))
    )
  : () => null;

const QueryDevtools = devtoolsEnabled
  ? lazy(() =>
      import("@tanstack/react-query-devtools").then((res) => ({
        default: res.ReactQueryDevtools,
      }))
    )
  : () => null;

export function DevTools() {
  return (
    <Suspense>
      <RouterDevtools position="bottom-right" router={router} />
      <QueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
    </Suspense>
  );
}
